import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { PageFavoriteExternalLink } from './PageFavoriteExternalLink';
import { PageFavoriteInternalLink } from './PageFavoriteInternalLink';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';
import React, { ComponentProps } from 'react';
import { FavoriteItem } from '../FavoritePagesTypes';
import { asView } from '../../../_lib/ViewFetcher';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type FavoritedPagesBlockDefaultViewProps = {
  items: FavoriteItem[];
};

export function FavoritedPagesDefaultView({ items }: FavoritedPagesBlockDefaultViewProps) {
  const { t } = useSonTranslation('FavoritedPages');

  if (!items || items.length === 0) {
    return <ContentMessage text={t('deletableItem.noContent')} />;
  }

  return (
    <ScrollArea to={100} bottomOffset={10}>
      <ContentList ordered>{
        items.map(item =>
          <ContentListItem key={item.id}>
            {item.content.pageLink.external
              ? (
                  <PageFavoriteExternalLink {...item} />
                )
              : (
                  <PageFavoriteInternalLink {...item} />
                )}
          </ContentListItem>)
      }
      </ContentList>
    </ScrollArea>
  );
}

export const FavoritedPagesBlockDefaultView = asView(FavoritedPagesDefaultView);
export type FavoritedPagesBlockDefaultView = ComponentProps<typeof FavoritedPagesBlockDefaultView>;
